// extracted by mini-css-extract-plugin
export var adIconColors = "sJqL2";
export var alwaysShowPropertyIcons = "u6qq3";
export var applyDefaultIconColor = "Suhth";
export var denseless = "qL92s";
export var disabledHoverActionCursor = "Ar46p";
export var full = "suvGu";
export var hoverActionButton = "N95kH";
export var hoverActionIcon = "BXibp";
export var hoverIconInIconBar = "mbQ9W";
export var icon = "kElPw";
export var iconBarContainer = "bvdCQ";
export var iconBarLeftMargin = "pY8AN";
export var iconBarNoLeftMargin = "mQaQq";
export var iconContainerNew = "hnzOS";
export var iconDisplay = "Q_UHS";
export var iconHide = "W_gAr";
export var iconInIconBar = "pDxoJ";
export var iconNoDisplay = "pPZMd";
export var iconNotSupportedVisibility = "swPrc";
export var propertyIcon = "gXxPA";